<template>
  <app-section theme="nude" class="v2-prohibited-content">
    <div class="row">
      <prohibited-content-text />
    </div>
  </app-section>
</template>

<script setup lang="ts">
import AppSection from "@/components/v2/section/index.vue";
import ProhibitedContentText from "@/components/prohibited-content-text/index.vue";

defineOptions({
  name: "prohibited-content-v2",
});
</script>
